import IconButton from '@/storybook/components/IconButton/IconButton';
import Text from '@/storybook/components/Text/Text';
import ChevronLeftIcon from '@/storybook/icons/ChevronLeftIcon';
import ChevronRightIcon from '@/storybook/icons/ChevronRightIcon';
import OutlineBarsIcon from '@/storybook/icons/OutlineBarsIcon';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import ToggleButtonGroup from '@/storybook/components/ToggleButtonGroup/ToggleButtonGroup';
import { viewControls } from '../helpers';
import styles from './SingleDatePickerHeader.module.css';

type CalendarView = 'week' | 'month' | 'year';

type DatePickerHeaderProps = ReactDatePickerCustomHeaderProps & {
  view: CalendarView;
  setView: (view: CalendarView) => void;
  setDate: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
};

export function SingleDatePickerHeader({ date, view, setView, setDate, minDate, maxDate }: DatePickerHeaderProps) {
  const { next, prev, formatter } = viewControls[view];

  const nextDate = next(date);
  const prevDate = prev(date);

  const handleNext = () => {
    if (!maxDate || nextDate <= maxDate) {
      setDate(nextDate);
    }
  };

  const handlePrev = () => {
    if (!minDate || prevDate >= minDate) {
      setDate(prevDate);
    }
  };

  const isPrevDisabled = !!minDate && prevDate < minDate;
  const isNextDisabled = !!maxDate && nextDate > maxDate;

  return (
    <div className={styles.customHeaderWrapper}>
      <ToggleButtonGroup
        options={[
          { label: 'Week', value: 'week', icon: <OutlineBarsIcon /> },
          { label: 'Month', value: 'month', icon: <OutlineBarsIcon /> },
          { label: 'Year', value: 'year', icon: <OutlineBarsIcon /> },
        ]}
        value={view}
        onChange={setView}
      />
      <div className={styles.navigationWrapper}>
        <IconButton
          size="M"
          appearance="text"
          onClick={handlePrev}
          disabled={isPrevDisabled}
          data-testid="navigationPrev"
          icon={<ChevronLeftIcon />}
        />
        <Text className={styles.paginationHeaderText}>{formatter(date)}</Text>
        <IconButton
          size="M"
          appearance="text"
          onClick={handleNext}
          disabled={isNextDisabled}
          data-testid="navigationNext"
          icon={<ChevronRightIcon />}
        />
      </div>
    </div>
  );
}
